import React from 'react';

import { useQueryAnalyticsFile } from '@ion/api';

import { HOSTING_TYPES } from 'app/components/analytics-builder/analytics-builder-file-hosting';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';

import AnalyticsFileTableTitle from './AnalyticsFileTableTitle';
import BuildNewFileButton from './BuildNewFileButton';
import buildAnalyticsFileTableContents from './buildAnalyticsFileTableContents';
import buildEndpointUrls from './buildEndpointUrls';

export default function useAnalyticsFileTable() {
  const { pipelineId, pipeline } = usePipelinePageContext();

  const { data: analyticsFile } = useQueryAnalyticsFile({
    variables: { pipelineId },
  });

  const isMRHosted = analyticsFile?.settings?.fileHostingType === HOSTING_TYPES.metaRouter;

  const endpointUrls = buildEndpointUrls({ analyticsFile, pipeline, showMRHostedUrls: isMRHosted });

  return {
    tableProps: {
      numberOfColumns: 2,
      data: buildAnalyticsFileTableContents({ analyticsFile }),
      title: <AnalyticsFileTableTitle />,
      actions: <BuildNewFileButton />,
    },
    endpointUrls,
  };
}
